import { PropsWithChildren, useCallback, useEffect } from "react";

import ReactGA from "react-ga4";

import { TrackingContext } from "./trackingContext";
import { TrackPurchaseProps } from "./types";

export function TrackingProvider(props: PropsWithChildren) {
  const trackEvent = useCallback(
    (name: string, props?: Record<string, unknown>) => {
      ReactGA.event(name, props);
    },
    []
  );

  const trackPurchase = useCallback((props: TrackPurchaseProps) => {
    ReactGA.event("purchase", {
      ...props,
      currency: "USD",
      tax: 0,
      shipping: 0,
      items: [],
    });
  }, []);

  useEffect(() => {
    ReactGA.initialize(process.env.VITE_GA_MEASUREMENT_ID || "");
  }, []);

  return (
    <TrackingContext.Provider
      value={{ trackEvent, trackPurchase }}
      {...props}
    />
  );
}
